export default __webpack_public_path__ + "static/media/cityscape.26259045.svg";